"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scalarTypes = void 0;
const scalarTypes = {
    boolean: 'Boolean',
    integer: 'Int',
    number: 'Float',
    string: 'String'
};
exports.scalarTypes = scalarTypes;
